<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
    </div>
    <select :name="`select_${id}`" class="input" :style="valueStyle" v-model="value" @change="priceTarget">
      <option v-for="(option, index) in itemSetting.action.item" :key="index" :value="`${index}_${option.value}`">
        <span v-html="option.label[lang]"></span>
        <span v-if="!hiddenPrice" class="optionPrice notranslate"> {{priceFormat(option.price)}}</span>
      </option>
    </select>
    <!-- 옵션별 선택에 따른 추가옵션(서브) -->
    <div v-if="selectOption && selectOption.value === value.split('_').splice(1).join('') && getSubOption(selectOption)" class="break">
      <!-- <button
        type="button"
        class="btn btnWhite sizeXs mt5"
        @click="setSubOption(selectOption)">
        {{selectOption.label[lang]}} > {{locale.page_suboption}}
      </button> -->
      <div v-for="sub in getSubOption(selectOption)"
        :key="sub.id"
        class="subOption">
        <component
          :is="sub.name.replace(/\b\w/g, l => l.toUpperCase())"
          :locale="locale"
          :lang="lang"
          :id="sub.id"
          :itemSetting="sub.setting"
          :subOption="subOption"
          :isSub="true" />
      </div>
    </div>
    <!-- //옵션별 선택에 따른 추가옵션(서브) -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import regExp from '@/common/regExp'

export default {
  name: 'Select',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'isSub',
    'subOption',
    'storageData',
    'hiddenPrice'
  ],
  components: {
    Input: () => import('./Input.vue'),
    Checkbox: () => import('./Checkbox.vue'),
    Radio: () => import('./Radio.vue'),
    Select: () => import('./Select.vue')
  },
  computed: {
    ...mapGetters({
      price: 'page/getPrice',
      submitData: 'submit/getSubmitData'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    hasPrice () {
      return this.$store.state.page.hasPrice
    },
    value: {
      get () {
        const data = this.submitData.find(x => x.id === this.id) ? this.submitData.find(x => x.id === this.id).value : ''
        return data
      },
      set (value) {
        this.setSubmitData(value)
      }
    },
    moduleAll () {
      return this.$store.getters['page/getPage']
    },
    subOptions () {
      const moduleAll = this.moduleAll.module
      const sub = this.submitData && this.submitData.find(x => x.id === this.id) ? this.submitData.find(x => x.id === this.id).subOption : []
      return sub && moduleAll
        ? moduleAll.filter(x => sub.map(s => s.subOption).includes(x.id))
        : null
    },
    selectOption () {
      const index = Number(this.value.split('_').splice(0)[0])
      const value = this.value.split('_').splice(1).join('')
      return this.itemSetting.action.item.find((x, i) => x.value === value && i === index)
    }
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        if (value) {
          this.setSubmitData(value)
        }
      }
    },
    hasPrice (hasPrice) {
      if (hasPrice) {
        const option = this.itemSetting.action.item[0]
        this.priceOption(option)
      }
    }
  },
  data () {
    return {
      message: 'is required'
    }
  },
  methods: {
    setSubmitData (value) {
      const options = this.itemSetting.action.item
      const data = {
        id: this.id,
        value: value,
        valueOption: options,
        passed: true
      }
      this.$store.commit('submit/setValue', data)
    },
    priceTarget (e) {
      const index = e.target.selectedIndex
      const option = this.itemSetting.action.item[index]
      this.priceOption(option)
    },
    priceFormat (price) {
      const code = this.currency
      return price ? regExp.priceFormat(price, code) : ''
    },
    priceOption (option) {
      const lang = this.lang
      const p = regExp.uncomma(option.price)
      const price = typeof (p) === 'undefined' || p === '' ? 0 : Number(p.replace(/\(|\)|\+/g, ''))
      const value = this.value.split('_').splice(1).join('')
      const data = {
        id: this.id,
        itemLabel: this.itemSetting.action.labelValue,
        label: option.label[lang],
        price: price,
        ...this.subOptions && {
          subOptionList: this.subOptions.map(x => x.id),
          ...this.subOption.find(x => x.parentValue === value) && {
            subOptionValue: this.subOption.find(x => x.parentValue === value).child
          }
        },
        ...this.isSub && {
          isSub: this.isSub,
          parentOption: this.itemSetting.action.parentOption
        }
      }
      this.$store.commit('page/priceOption', data)
    },
    getSubOption (option) {
      const mods = this.subOptions ? this.subOptions.filter(x => x.id === option.subOption) : null
      return mods
    }
  }
}
</script>
